import ValidationError from "../validationError";
import {ErrorType} from "~/enums/ErrorType";
import {DurationUnit} from "~/enums/durationUnit"
import {minMaxType} from "~/enums/minMaxValidatorType"
import NavigableValidator, {INavigableValidatorOptions} from "~/models/navigableValidators/navigableValidator";

interface IMinMaxFieldValidatorOptions {
  min_field: string,
  max_field: string,
  minMaxType: number,
  min_field_unit?: any,
  max_field_unit?: any,
  conditional_field?: any
}

export default class MinMaxFieldValidator<T> extends NavigableValidator<T> {
  max_field: any;
  max_field_unit: any;
  min_field: any;
  min_field_unit: any;
  conditional_field: any;
  minMaxType: number;
  defaultType = ErrorType.invalidValue;
  defaultMessage = "Min input cannot be higher than max";

  constructor(options: Partial<IMinMaxFieldValidatorOptions> & Partial<INavigableValidatorOptions<T>>) {
    super(options);
    this.minMaxType = options.minMaxType;
    this.min_field = options.min_field;
    this.max_field = options.max_field;
    this.min_field_unit = options.min_field_unit;
    this.max_field_unit = options.max_field_unit;
    this.conditional_field = options.conditional_field;
  }
  _validate(model): void {
    //check for presence and if conditional field is defined. !! operator to account for checkbox 1/0 input
    if (model[this.min_field] && model[this.max_field] && (this.conditional_field === undefined || !!model[this.conditional_field] === true)) {
      let comparison_min;
      let comparison_max;
      if (this.minMaxType === minMaxType.duration){
        comparison_min = this.convertTimeDurationToMinutes(model[this.min_field], model[this.min_field_unit]);
        comparison_max = this.convertTimeDurationToMinutes(model[this.max_field], model[this.max_field_unit]);
      }else{
        comparison_min = model[this.min_field];
        comparison_max = model[this.max_field];
      }
      if (comparison_min > comparison_max){
        this.errors.push(this.buildValidationError(model));
      }
    }
  }
  convertTimeDurationToMinutes(field, unit){
    let field_in_mins;
    switch (unit) {
      case DurationUnit.hour:
        field_in_mins = field*60;
        break;
      case DurationUnit.day:
        field_in_mins=field*60*24;
        break;
      default:
        field_in_mins= field;
    }
    return field_in_mins
  }

  fieldNameForDisplay(field){
    let map = field.split("_").map(x=> x.charAt(0).toUpperCase() + x.slice(1) );
    return map.join(" ")
  }

  buildValidationError(model: any, value?, type?) {
    return new ValidationError({
      message: value || this.options.message || this.defaultMessage,
      displayName: `${this.fieldNameForDisplay(this.field)}`,
      errorNavOpts: model.validation.errorNavOpts(this, this.field, model),
      type: type || this.defaultType,
      section: this.section
    });
  }

}